import { Button } from "react-bootstrap";
import styled, { css } from "styled-components";

const getVariantStyles = ({ variant = 'neutral', outline = false, theme }) => {
  const variants = {
    neutral: {
      filled: css`
        background-color: ${theme.colors['neutral-07']};
        border: 1px solid ${theme.colors['neutral-07']};
        color: ${theme.colors['neutral-01']};

        &:hover {
          color: ${theme.colors['neutral-01']};
        }
      `,
      outline: css`
        background-color: transparent;
        border: 1px solid ${theme.colors['neutral-01']};
        color: ${theme.colors['neutral-01']};

        &:hover {
          color: ${theme.colors['neutral-01']};
        }
      `
    },
    green: {
      filled: css`
        background-color: ${theme.colors['branding-01']};
        border: 1px solid ${theme.colors['branding-01']};
        color: ${theme.colors['neutral-01']};

        &:hover {
          color: ${theme.colors['neutral-01']};
        }
      `,
      outline: css`
        background-color: transparent;
        border: 1px solid ${theme.colors['vivid-01']};
        color: ${theme.colors['vivid-01']};

        &:hover {
          color: ${theme.colors['vivid-01']};
        }
      `
    },
    purple: {
      filled: css`
        background-color: ${theme.colors['branding-04']};
        border: 1px solid ${theme.colors['branding-04']};
        color: ${theme.colors['neutral-01']};

        &:hover {
          color: ${theme.colors['neutral-01']};
        }
      `,
      outline: css`
        background-color: transparent;
        border: 1px solid ${theme.colors['vivid-04']};
        color: ${theme.colors['vivid-04']};

        &:hover {
          color: ${theme.colors['vivid-04']};
        }
      `
    }
  };

  return variants[variant][outline ? 'outline' : 'filled'];
};

export const BlogButton = styled.a`
  text-decoration: none;
  width: 100%;
  padding: 0 8px;
  height: 40px;
  border-radius: 100px;
  font-weight: 500;
  letter-spacing: 1.2px;
  font-size: 14px;
  line-height: 24px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-transform: uppercase;

  ${props => getVariantStyles(props)}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  img, svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    filter: brightness(0.8);
  }
`;
